/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ListNumberedIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABRUlEQVR4nO2Vu0oEMRSGxwvqA2gh2NvbicWAIIw45+REyJ5/2GJ7sdbOLbzgK9j6FFp5WXwAwUYEsdFWEKwUlczuIOK4swtZQfCDQEJIPk5I/kTRLzNEFou0WlsIvrNzbowFuyx4Z8FtcAGLXvnNyeB1IAIyuCaj2yR6PxBB3GhM5KISAQkuOkfXWzPa+rmSEgEbbfUjIMF5X4IgsNE9Fhyw4JkET+2+boUU3H0vVy+DCf6ppNlsDqeiy6nJ1sgi8ePqVT2SJMk4Gz39+lhw7JwbCSJIbW2ORB992Flbn2bBoZekksVBBLkkzSbjOB71fTLYyauwWIlC4s+djG6y4IUFN5/5VJFF3bKnIHFuigRnnSw5sbY+U8xVZVHX7Ckg0SMWvJHBRtAb5GF2s+3PRh9YsF+0VLL5KARksVReuq4HEfxpPgA1ltwfmuKABQAAAABJRU5ErkJggg==)
 */
export const ListNumberedIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M5.87 8.42h1.95V10h-5.7V8.42H4.1V3.8C3.74 4.57 3.09 5 2.13 5.12V3.14c.41-.05.8-.2 1.19-.46.37-.26.63-.58.78-.96h1.77v6.7ZM10 5a1 1 0 0 0 0 2h11a1 1 0 1 0 0-2H10ZM10 17a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2h-7ZM7.42 22v-1.51h-3.8c.08-.27.24-.52.5-.76.26-.25.61-.5 1.07-.77.78-.44 1.34-.89 1.67-1.33.33-.44.5-.95.5-1.53 0-.78-.26-1.4-.77-1.85-.51-.47-1.2-.7-2.06-.7-.8 0-1.43.18-1.92.54-.48.36-.83.83-1.03 1.4l1.4.8c.14-.4.34-.7.59-.9.25-.22.55-.33.87-.33.39 0 .68.1.88.28.2.18.31.43.31.73 0 .28-.09.55-.26.8-.18.23-.54.51-1.08.83-.56.33-1.01.64-1.36.92-.33.28-.62.66-.86 1.14a4.01 4.01 0 0 0-.35 1.77V22h5.7Z"
        className={colorClass}
      />
    </svg>
  );
};
